import { type ReactElement } from 'react'

class MaTab {
  public key: string
  public component: ReactElement
  public hasData: boolean
  public visible: boolean
  public title: string | undefined
  public closable: boolean
  public elementIsComponent: boolean

  // eslint-disable-next-line @typescript-eslint/max-params -- too many params
  constructor (
    key: string,
    component: ReactElement,
    hasData = true,
    visible = true,
    title: string | undefined = undefined,
    closable = false,
    elementIsComponent = false
  ) {
    this.key = key
    this.component = component
    this.hasData = hasData
    this.visible = visible
    this.title = title
    this.closable = closable
    this.elementIsComponent = elementIsComponent
  }
}

export default MaTab
